module.exports = __webpack_public_path__ + "img/face-smile-horns.eba6e06b.svg";